var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Stop component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconStop extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41624 2.60474C2.96846 2.60474 2.60547 2.96773 2.60547 3.41551V20.584C2.60547 21.0317 2.96846 21.3947 3.41624 21.3947H20.5847C21.0325 21.3947 21.3955 21.0317 21.3955 20.584V3.41551C21.3955 2.96773 21.0325 2.60474 20.5847 2.60474H3.41624ZM1.10547 3.41551C1.10547 2.1393 2.14004 1.10474 3.41624 1.10474H20.5847C21.8609 1.10474 22.8955 2.1393 22.8955 3.41551V20.584C22.8955 21.8602 21.8609 22.8947 20.5847 22.8947H3.41624C2.14004 22.8947 1.10547 21.8602 1.10547 20.584V3.41551Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconStop.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconStop.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconStop.prototype, "size", void 0);
if (customElements.get('cat-icon-stop') === undefined) {
    customElements.define('cat-icon-stop', BlocksIconStop);
}
